import PropTypes from 'prop-types';
import Text from '../typography/text';
import * as style from './progressBar.module.scss';

const ProgressBar = ({ current, tiers, label = 'monthly donors' }) => {
  const validTiers = tiers.filter((tier) => tier > current);
  // A default that will at least make the gauge look reasonable correct
  // in cases where we bust through the provided range.
  const nextTier =
    validTiers.sort((a, b) => {
      a > b;
    })[0] || Math.ceil(current * 1.25);
  return (
    <div className={`container ${style.progress}`}>
      <progress value={current} max={nextTier} />
      <Text as="span">
        <strong>{`${current.toLocaleString()} so far! `}</strong>
        {`Let’s get to ${nextTier.toLocaleString()} ${label}!`}
      </Text>
    </div>
  );
};

ProgressBar.propTypes = {
  current: PropTypes.number.isRequired,
  tiers: PropTypes.arrayOf(PropTypes.number).isRequired,
  label: PropTypes.string,
};

export default ProgressBar;
